import haversineDistance from "haversine-distance";
import { devLog } from "utils/devLog";

const webAppStateCleaner = function (state) {
  const cleanState = Object.assign({}, state);
  cleanState.memberSearchService = undefined;
  cleanState.navigationService = undefined;
  console.log("webAppStateCleaner: ", cleanState);
  return cleanState;
};

export async function apiProcessPayment(encCallGUID, email, companyParams, paymentID, callback) {
  try {
    const response = await fetch("/process-payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encCallGUID: encCallGUID,
        email: email,
        paymentID: paymentID,
        companyParams: companyParams,
      }),
    });

    const responseParams = await response.json();
    console.log("apiProcessPayment params", responseParams);

    if (callback) {
      callback(responseParams);
    }
  } catch (error) {
    console.error("Error with calling /process-payment:", error);
  }
}

export async function apiLoginCompany(state, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/loginCompany`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tokenID: state.tokenID,
      }),
    });

    const companyParams = await response.json();
    console.log("companyParams", companyParams);

    if (callback) {
      callback(companyParams);
    }
  } catch (error) {
    console.error(`Error with /loginCompany api call. Error: ${error}`);
  }
}

export async function apiGetCallPending(state, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/getCallPending`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tokenID: state.tokenID,
        providerRef: state.providerRef,
        companyParams: state.currentCompanyParams,
      }),
    });

    const responseParams = await response.json();
    console.log("responseParams", responseParams);

    if (callback) {
      callback(responseParams);
    }
  } catch (error) {
    console.error(`Error with /getCallPending api call. Error: ${error}`);
  }
}

export async function apiGetCall(state, callback) {
  console.log("apiGetCall state: ", state);
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/getCall`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tokenID: state.tokenID,
        providerRef: state.providerRef,
        companyParams: state.currentCompanyParams,
        state: state,
      }),
    });
    console.log("apiGetCall response", response);
    const responseParams = await response.json();
    console.log("responseParams api", responseParams);

    if (responseParams.Status !== null) {
      if (responseParams.Status === "ERR") {
        console.log("apiGetCall ERR", responseParams.ErrorDesc);
        if (callback) {
          callback(null);
          return;
        }
      }
      const updatedParams = {
        ProviderRef: responseParams.ProviderRef || "",
        // Disablement Location Info
        DisablementAddress: responseParams.Address || "",
        DisablementStreet: responseParams.Street || "",
        DisablementCity: responseParams.City || "",
        DisablementState: responseParams.State || "",
        DisablementZip: responseParams.Zip || "",
        DisablementCountry: responseParams.Country || "",
        DisablementCoords: {
          lat: responseParams.Lat,
          lng: responseParams.Lng,
        },
        // Customer Information
        FirstName: responseParams.FirstName || "",
        LastName: responseParams.LastName || "",
        Number: responseParams.Number || "",
        // Vehicle Information
        Year: responseParams.VehicleYear || "",
        Make: responseParams.VehicleMake || "",
        Model: responseParams.VehicleModel || "",
        Color: responseParams.VehicleColour || "",
        Service: responseParams.ServiceTypes || "",
        Provider: responseParams.VehicleMake || "",
        WillRemainWithAuto: responseParams.RemainWithAuto,
        OnHighway: responseParams.OnHighway,
        DestinationAddress: responseParams.DestAddress || "",
        DestinationCompany: responseParams.DestCompanyName || "",
        DestinationStreet: responseParams.DestStreet || "",
        DestinationCity: responseParams.DestCity || "",
        DestinationState: responseParams.DestState || "",
        DestinationZip: responseParams.DestZip || "",
        DestinationCountry: responseParams.DestCountry || "",
        DestinationCoords: {
          lat: responseParams.DestLat,
          lng: responseParams.DestLng,
        },
        ServiceDetails: "",
        EnRouteData: {
          time: "updating",
          servProv: "updating",
          status: "updating",
          cancelFlag: false,
          helpFlag: false,
        },
        OperatorCoords: {
          lat: responseParams.RSALat,
          lng: responseParams.RSALng,
        },
        CallParams: {
          encCallGUID: responseParams?.encCallGUID,
          encComGUID: responseParams?.encComGUID,
          encOperComGUID: responseParams?.encOperComGUID,
          encPrevOperComGUID: responseParams?.encPrevOperComGUID,
          encPrevOperGUID: responseParams?.encPrevOperGUID,
          encPriComGUID: responseParams?.encPriComGUID,
          encProvGUID: responseParams?.encProvGUID,
          encTokenID: responseParams?.encTokenID,
          encUserGUID: responseParams?.encUserGUID,
        },
      };

      if (callback) {
        callback(updatedParams);
      }
    } else {
      console.log("apiGetCall Status returned was null");
      if (callback) {
        callback(null);
      }
    }
  } catch (error) {
    console.error(`Error with /getCall api call. Error: ${error}`);
  }
}

export async function apiSetSubmitStage(state, stage, note, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/setSubmitStage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        stage: stage,
        note: note,
        tokenID: state.tokenID,
        providerRef: state.providerRef,
        companyParams: state.currentCompanyParams,
      }),
    });

    // This API call doesn't send a response.
    console.log("setSubmitStage finished.");
    console.log(response);

    if (callback) {
      callback(response);
    }
  } catch (error) {
    console.error(`Error with /setSubmitStage api call. Error: ${error}`);
  }
}

export async function apiCreateCall(state, callData, callback) {
  try {
    state = webAppStateCleaner(state);
    console.log("CallData", callData);
    const response = await fetch(`/createCall`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        callData: callData,
        companyParams: state.currentCompanyParams,
      }),
    });

    console.log("CreateCall Response:", response);
    const callParams = await response.text();
    console.log("callParams", callParams);

    if (callback) {
      callback(callParams);
    }
  } catch (error) {
    console.error(`Error with /createCall api call. Error: ${error}`);
  }
}

export async function apiFeedbackSubmit(state, callData, callback) {
  state = webAppStateCleaner(state);
  console.log("State state.CallStatusParams.encCallGUID:", state.CallStatusParams.encCallGUID);
  console.log("State state.cid:", state.cid);
  const response = await fetch(`/setfeedback`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      state: state,
      callData: callData,
    }),
  });

  const callParams = await response.text();

  if (callback) {
    callback(callParams);
  }
}

export async function apiSubmitLocation(state, callback) {
  state = webAppStateCleaner(state);
  console.log("State state.CallStatusParams.encCallGUID:", state);
  console.log("State state.cid:", state.cid);
  const response = await fetch(`/usermaplocator`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idno: state.idno,
      ref: state.providerRef,
      lat: state.TTLObj.lat,
      lng: state.TTLObj.lng,
      street: state.TTLObj.street,
      city: state.TTLObj.city,
      state: state.TTLObj.state,
      country: state.TTLObj.country,
      zip: state.TTLObj.zip,
      onHighway: state.OnHighway,
    }),
  });

  const res = await response.json();

  if (res) {
    callback(res);
  }
}

export async function apiCancelCallPending(state, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/cancel-call-pending`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tokenID: state.tokenID,
        companyParams: state.currentCompanyParams,
        providerRef: state.providerRef,
        vendorRef: state.vendorRef,
      }),
    });

    const responseParams = await response.json();
    console.log("responseParams", responseParams);

    if (callback) {
      callback(responseParams);
    }
  } catch (error) {
    console.error(`Error in apiCancelCall with /cancel-call-pending api call. Error: ${error}`);
    if (callback) {
      callback(null);
    }
  }
}

export async function apiCancelCall(state, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/cancel-call`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tokenID: state.tokenID,
        companyParams: state.currentCompanyParams,
        callParams: state.CallParams,
      }),
    });

    const responseParams = await response.json();
    console.log("responseParams", responseParams);

    if (callback) {
      callback(responseParams);
    }
  } catch (error) {
    console.error(`Error in apiCancelCall with /cancel-call api call. Error: ${error}`);
  }
}

export async function apiGetCallStatus(state, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/getCallStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        callParams: state.CallParams,
        companyParams: state.currentCompanyParams,
      }),
    });

    console.log("apiGetCallStatus:", response);
    const callStatusParams = await response.json();
    console.log("apiGetCallStatusParams", callStatusParams);

    //this.setState({callStatusParams: callStatusParams});

    if (callback) {
      callback(callStatusParams);
    }
  } catch (error) {
    console.error(`Error with /getCallStatus api call. Error: ${error}`);
  }
}

export async function apiGetATFDestination(state, caseId, partner, callData, callback) {
  try {
    state = webAppStateCleaner(state);
    const response = await fetch(`/getPartnerLocations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        callData: callData,
        partner: partner,
        companyParams: state,
        caseId: caseId,
      }),
    });

    const AtfDestParams = await response.json();

    if (callback) {
      callback(AtfDestParams);
    }
  } catch (error) {
    console.error(`Error with /getCallStatus api call. Error: ${error}`);
  }
}

export async function apiRevGeocodeLocationGoogle(coords, callback) {
  try {
    const response = await fetch("/revgeocode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        coords: coords,
      }),
    });

    const geoCodedList = await response.json();
    //console.log("Results length", geoCodedList.results.length);

    let data = {};

    // after getting back data make it the same as here.com data
    if (geoCodedList.results.length > 0) {
      let streetNumber = "";
      let route = "";
      let locality = "";
      let sublocality = "";
      let adminLevel1 = ""; //administrative_area_level_1
      let adminLevel1Code = ""; // ie state code
      let adminLevel2 = ""; //administrative_area_level_2
      let country = "";
      let countryShort = "";
      let postalCode = ""; // postal_code
      let parkName = "";

      // for (var i = 0; i < geoCodedList.results.length; i++) {
      //     if (geoCodedList.results[i]?.address_components) {
      //     }
      // }
      console.log("result.address_components:", geoCodedList.results[0]?.address_components);

      let addressInfo = geoCodedList.results[0];
      for (let i = 0; i < geoCodedList.results.length; i++) {
        const result = geoCodedList.results[i];
        if (!Array.isArray(result.types)) {
          continue;
        }

        for (let j = 0; j < result.address_components.length; j++) {
          let component = result.address_components[j];
          if (!component) {
            continue;
          }

          if (!Array.isArray(component.types)) {
            continue;
          }
          if (!streetNumber && component.types.includes("street_number")) {
            streetNumber = component.long_name;
          } else if (!route && component.types.includes("route")) {
            route = component.long_name;
          } else if (!route && component.types.includes("plus_code")) {
            route = component.long_name;
          } else if (!locality && component.types.includes("locality")) {
            locality = component.long_name;
          } else if (
            !sublocality &&
            (component.types.includes("sublocality") || component.types.includes("neighborhood"))
          ) {
            sublocality = component.short_name;
          } else if (!adminLevel2 && component.types.includes("administrative_area_level_2")) {
            adminLevel2 = component.long_name; // county
          } else if (!adminLevel1 && component.types.includes("administrative_area_level_1")) {
            adminLevel1 = component.long_name; // state
            adminLevel1Code = component.short_name;
          } else if (!country && component.types.includes("country")) {
            country = component.long_name; // state
            countryShort = component.short_name;
          } else if (!postalCode && component.types.includes("postal_code")) {
            postalCode = component.long_name; // zip
          } else if (!parkName && component.types.includes("park")) {
            parkName = component.long_name; // park name
          }
        }
      }

      /*let addressInfo = geoCodedList.results[0];
            for (var i = 0; i < addressInfo.address_components.length; i++) {
                let component = addressInfo.address_components[i];
                if (component.types.includes('street_number')) {
                    streetNumber = component.long_name;
                } else if (component.types.includes('route')) {
                    route = component.long_name;
                } else if (component.types.includes('locality')) {
                    locality = component.long_name;
                } else if (component.types.includes('sublocality')) {
                    sublocality = component.short_name;
                } else if (component.types.includes('administrative_area_level_2')) {
                    adminLevel2 = component.long_name; // county
                } else if (component.types.includes('administrative_area_level_1')) {
                    adminLevel1 = component.long_name; // state
                    adminLevel1Code = component.short_name
                } else if (component.types.includes('country')) {
                    country = component.long_name; // state
                    countryShort = component.short_name;
                } else if (component.types.includes('postal_code')) {
                    postalCode = component.long_name; // zip
                }
            }*/

      console.log("streetNumber:", streetNumber);
      console.log("route:", route);
      console.log("locality:", locality);
      console.log("sublocality:", sublocality);
      console.log("adminLevel1:", adminLevel1);
      console.log("adminLevel1Code:", adminLevel1Code);
      console.log("adminLevel2:", adminLevel2);
      console.log("country:", country);
      console.log("countryShort:", countryShort);
      console.log("postalCode:", postalCode);
      console.log("parkName:", parkName);

      data = {
        title: addressInfo.formatted_address || "",
        address: {
          label: addressInfo.formatted_address || "",
          houseNumber: streetNumber,
          street: route,
          city: locality && locality.length > 0 ? locality : sublocality,
          county: adminLevel2,
          state: adminLevel1,
          stateCode: adminLevel1Code,
          countryName: country,
          countryCode: countryShort,
          postalCode: postalCode,
          parkName: parkName,
        },
        position: coords,
      };

      // console.log("Data:", data);
    }

    if (callback) {
      callback(data);
    }
  } catch (error) {
    console.error("Error rev geocoding with google:", error);
  }
}

export async function apiRevGeocodeLocationGoogleList(coords, callback) {
  try {
    const response = await fetch("/revgeocode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        coords: coords,
      }),
    });

    const geoCodedList = await response.json();
    //console.log("Results length", geoCodedList.results.length);

    let addressList = [];

    // after getting back data make it the same as here.com data
    if (geoCodedList.results.length > 0) {
      console.log("apiRevGeocodeLocationGoogleList result.address_components:", geoCodedList.results);

      let results = geoCodedList.results;
      let plusCodeResults = [];
      for (let i = 0; i < results.length; i++) {
        const result = geoCodedList.results[i];

        if (!Array.isArray(result.types)) {
          continue;
        }

        if (result.geometry?.location_type === "APPROXIMATE") {
          continue;
        }
        if (!addressList.find((address) => address.formatted_address === result.formatted_address)) {
          if (result.types.find((type) => type === "plus_code")) {
            let distancePC =
              Math.ceil(haversineDistance(coords, result.geometry.location) * 0.000621371192 * 100) / 100;
            plusCodeResults.push({
              ...result,
              distance: distancePC,
            });
          } else {
            const distance = haversineDistance(coords, result.geometry.location);
            addressList.push({
              ...result,
              distance: Math.ceil(distance * 0.000621371192 * 100) / 100,
            });
          }
        }
      }
      addressList.sort((a, b) => a.distance - b.distance);
      addressList = [...addressList, ...plusCodeResults];
    }

    if (callback) {
      console.log("apiRevGeocodeLocationGoogleList callback:", addressList);
      callback(addressList);
    }
  } catch (error) {
    console.error("Error rev geocoding with google:", error);
  }
}

export async function getNearbyPlaces(coords, keyword, callback) {
  //console.log("do we get here")
  try {
    const response = await fetch(`/nearbyplaces`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        coords: coords,
        keyword: keyword,
      }),
    });

    const placesList = await response.json();
    // console.log("TrxNowAPI placesList", placesList);

    if (callback) {
      callback(placesList);
    }
  } catch (error) {
    console.error(`Error getting nearby places: ${error}`);
  }
}

export async function getDistanceMatrix(currLat, currLng, destCoords, callback) {
  try {
    const origins = {
      waypoint: {
        location: {
          latLng: {
            latitude: currLat,
            longitude: currLng,
          },
        },
      },
    };

    const destinations = destCoords.map((destCoord) => {
      return {
        waypoint: {
          location: {
            latLng: {
              latitude: destCoord.lat,
              longitude: destCoord.lng,
            },
          },
        },
      };
    });

    const response = await fetch(`/distancematrix`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        origins: origins,
        destinations: destinations,
        travelMode: "DRIVE",
        routingPreference: "TRAFFIC_UNAWARE",
      }),
    });

    const distanceMatrix = await response.json();

    const sortedDistanceMatrix = distanceMatrix.sort((a, b) => a.destinationIndex - b.destinationIndex);
    console.log("sorted distanceMatrix: ", sortedDistanceMatrix);

    if (callback) {
      callback(sortedDistanceMatrix);
    }
  } catch (error) {
    console.error(`Error getting nearby places: ${error}`);
  }
}

export async function apiGetAutocompleteList(searchString, lat, lng, callback) {
  try {
    const response = await fetch("/autocompleteList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        searchString: searchString,
        lat: lat,
        lng: lng,
      }),
    });

    const locationsList = await response.json();

    if (callback) {
      callback(locationsList);
    }
  } catch (error) {
    console.error("Error getting autocomplete places:", error);
  }
}

export async function apiGeolocateGoogle(address, callback) {
  try {
    const response = await fetch("/geolocateGoogle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        address: address,
      }),
    });

    response.json().then((coords) => {
      console.log("Geolocated coords", coords);

      if (callback) {
        callback(coords);
      }
    });
  } catch (error) {
    console.error("Error with Google Geocoding:", error);
  }
}

export async function apiAddressToCoords(address, callback) {
  try {
    const response = await fetch("/addressToCoords", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        address: address,
      }),
    });

    const coordsList = await response.json();
    console.log(coordsList);
    if (coordsList?.items?.length > 0) {
      const coords = coordsList.items[0].position;
      console.log(coords);

      if (callback) {
        callback(coords);
      }
    }
  } catch (error) {
    console.error("Error getting coords from address:", error);
  }
}

// Testing this call:
// http://localhost:3000?tokenid=EOXmmrQVVoMJmTq_y5RkvPop1PS3vyRrzmHg19HA1uHK
//https://www.rapitow.com/sandbox/appserver?qr=getcallreport
//&hcid=EBXhuXRW8Xdh8c2RhCU0kKpAS5aZ4K2v2HWsL98WnUpK2-SXXSh-14kn_KctzcgdlNSmbu4J5O1uxYPN04vS1Bd11P5KNvdYLjobtpPBBzAlrevmioYX4aDpNJK5lb16PQ
//&ts=20221215142419
//&hmac=5d0d34875c8fb776e100aa04dbf8dce2df25b0592ddf36b8c56c14e9e2c332e3
export async function apiGetCallsReport(companyParams, callback) {
  console.log("apiGetCallsReport:", companyParams);

  try {
    const response = await fetch(`/getcallsreport`, {
      method: "POST",
      body: JSON.stringify({
        companyParams: companyParams,
      }),
    });

    //console.log("Response:", response);
    const responseFixed = await response.text();
    console.log("response", responseFixed);

    if (callback) {
      callback(responseFixed);
    }
  } catch (error) {
    console.error(`Error with /getcallsreport api call. Error: ${error}`);
  }
}

/**
 * Callout to retrieve the policy information supplied by the member
 * @param {*} state
 * @param {Function} callback
 */
export async function apiGetPolicyInfo(data) {
  devLog("apiGetPolicyInfo callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/getAPIPolicyInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    devLog("apiGetPolicyInfo response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetPolicyInfo api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to submit the policy information supplied by the member
 * @param {*} state
 * @param {Function} callback
 */
export async function apiSubmitPolicyInfo(data) {
  console.log("apiSubmitPolicyInfo callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/submitAPIPolicyInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiSubmitPolicyInfo response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.log(`Error with /apiSubmitPolicyInfo api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to vehicle search
 * @param {*} state
 * @param {Function} callback
 */
export async function apiVehicleSearch(data) {
  console.log("apiVehicleSearch callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/vehicleSearch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiVehicleSearch response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.log(`Error with /apiVehicleSearch api call. Error: ${error}`);
    throw error;
  }
}

export async function apiCheckPepBoysStore(data) {
  console.log("apiCheckPepBoysStore callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/checkPepBoysLocation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiCheckPepBoysStore response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiCheckPepBoysStore api call. Error: ${error}`);
    throw error;
  }
}

export async function apiGetSearchDestination(data) {
  console.log("apiGetSearchDestination callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/destinations/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetSearchDestination response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /destinations/search api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to submit the policy information supplied by the member
 * @param {*} state
 * @param {Function} callback
 */
export async function apiGetFeedbackStatus(data) {
  console.log("apiGetFeedbackStatus callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/feedbackStatus/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetFeedbackStatus response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetFeedbackStatus api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to submit feedback interaction status
 * This is not for submitting feedback!
 * @param {*} state
 * @param {Function} callback
 */
export async function apiSetFeedbackStatus(data) {
  console.log("apiSetFeedbackStatus callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/feedbackStatus/set`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiSetFeedbackStatus response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiSetFeedbackStatus api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to salesforce and get the destination list
 * @param {*} state
 * @param {Function} callback
 */
export async function apiGetDestinations(data) {
  console.log("apiGetDestinations callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/destinations/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetDestinations response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info.data;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetDestinations api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to salesforce and mark the case as deflected
 * @param {*} state
 * @param {Function} callback
 */
export async function apiSetDeflected(data) {
  console.log("apiGetDestinations callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/deflect`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetDestinations response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info.data;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetDestinations api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to salesforce and get the partner vendor list
 * @param {*} state
 * @param {Function} callback
 */
export async function apiGetVendorList(data) {
  console.log("apiGetVendorList callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/vendor/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetVendorList response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info.data;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetVendorList api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to salesforce and get the partner vendor list
 * @param {*} state
 * @param {Function} callback
 */
export async function apiSetVendor(data) {
  console.log("apiSetVendor callout:", data);
  if (typeof data !== "object") {
    throw new Error("Invalid data param");
  }

  try {
    const response = await fetch(`/vendor/set`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiSetVendor response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info.data;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiSetVendor api call. Error: ${error}`);
    throw error;
  }
}

/**
 * Callout to retrieve the app config from Salesforce
 * @param {*} webAppState
 * @param {Function} callback
 * @returns {clientApp}
 * @returns {towReasons}
 */
export async function apiGetAppConfig(webAppState) {
  console.log("apiGetAppConfig callout:", webAppState);
  if (typeof webAppState !== "object") {
    throw new Error("Invalid data param");
  }

  let data = {
    data: {
      providerRef: webAppState.providerRef,
    },
    companyParams: webAppState.currentCompanyParams,
  };

  try {
    const response = await fetch(`/getAppConfig`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const payload = await response.json();
    console.log("apiGetAppConfig response:", payload);

    if (typeof payload.Info === "string") {
      try {
        payload.Info = JSON.parse(payload.Info);
        if (typeof payload.Info === "object") {
          return payload.Info.data;
        }
      } catch (e) {
        console.error(e);
      }
    }

    return payload;
  } catch (error) {
    console.error(`Error with /apiGetAppConfig api call. Error: ${error}`);
    return;
  }
}
